module.exports = __webpack_public_path__ + "img/weight-b-.00ca0937.png";